import TrendingTopicsCarouselComponent from './TrendingTopicsCarouselComponent';

global.TrendingTopicsCarouselComponent = TrendingTopicsCarouselComponent;
